<template>
  <div class="d-flex align-items-center justify-content-center flex-column" style="position: fixed; top: 0; bottom: 0; left: 0; right: 0">
    <b-alert :show="busy" variant="primary">Connecting your Stream Deck to E-CARE</b-alert>
    <b-alert :show="!busy" variant="success">Your Stream Deck is now connected to E-CARE</b-alert>
    <b-btn v-show="!busy" variant="primary" @click="close">Close</b-btn>
  </div>
</template>

<script>

const STREAMDECK_PLUGIN_ID = 'com.e-crane.sdplugin';


export default
{
    data()
    {
        return { busy: true }
    },
    async mounted()
    {
        const today       = new Date();
        const displayName = `Stream Deck - Connected on ${today.toISOString()}`;

        const { data } = await this.$apollo.mutate(
            {
                mutation: require('../../../gql/createApiKey.gql'),
                variables:  { input: { displayName } }
            }
        );

        const key = data.createApiKey.string;

        window.open(`streamdeck://plugins/message/${STREAMDECK_PLUGIN_ID}/connect?streamdeck=hidden&apiKey=${key}`, '_self');

        this.busy = false;
    },
    methods:
    {
        close()
        {
            window.close();
        }
    }
}
</script>

<style>
</style>